import { render, staticRenderFns } from "./DataTableEditorView.vue?vue&type=template&id=6504df5d"
import script from "./DataTableEditorView.vue?vue&type=script&lang=js"
export * from "./DataTableEditorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports